export const works = [
  {
    id: "american-beauty",
    title: "美国丽人",
    en: "American Beauty",
    year: "1999",
    region: "美国",
    director: "萨姆·门德斯",
    rating: "R",
    genres: ["urban", "family"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20illustration%20of%20a%20single%20crimson%20rose%20petal%20drifting%20past%20a%20dim%20suburban%20window%20at%20dusk%2C%20muted%20warm%20amber%20and%20deep%20shadow%2C%20melancholic%20quiet%20mood%2C%20soft%20film%20grain%20texture%2C%20minimal%20artistic%20composition&width=600&height=900&seq=work-american-beauty&orientation=portrait",
    summary:
      "一个看似美满的中产家庭，在父亲的中年倦怠、母亲的功利焦虑与女儿的疏离中逐渐解体。影片用玫瑰花瓣与飘散的塑料袋，把「体面」背后的空虚构造成一个精确的隐喻。",
    review:
      "它常被误读为一部「中年男人危机片」，但真正的主角是这个家庭的共同谎言。导演没有把任何一个人写成纯粹的恶人：每个人都在用自己的方式追求被看见。当结尾的枪声响起，影片给出的是一个关于「在庸常中苏醒有多困难」的提问，而非廉价的道德判决。",
    themes: ["中产幻象", "欲望的错位", "被忽略的孤独"],
  },
  {
    id: "revolutionary-road",
    title: "革命之路",
    en: "Revolutionary Road",
    year: "2008",
    region: "美国",
    director: "萨姆·门德斯",
    rating: "R",
    genres: ["marriage"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20illustration%20of%20a%20mid-century%20living%20room%20with%20two%20distant%20silhouettes%20standing%20apart%20near%20a%20large%20window%2C%20pale%20grey%20and%20warm%20beige%20palette%2C%20restrained%20melancholic%20atmosphere%2C%20soft%20grain&width=600&height=900&seq=work-revolutionary-road&orientation=portrait",
    summary:
      "一对自认与众不同的郊区夫妻，计划搬去巴黎重启人生，却在现实与虚荣的拉扯中，把这个共同梦想一点点耗成了互相指责的武器。",
    review:
      "它可能是最不留情面的婚姻电影之一。影片拆穿了一个温柔的谎言：把「我们和别人不一样」当成关系支柱。当巴黎计划破产，丈夫的妥协与妻子的窒息形成尖锐对照。结尾早餐桌上的沉默，比任何争吵都更让人不安。",
    themes: ["婚姻幻灭", "平庸的窒息", "自我欺骗"],
  },
  {
    id: "marriage-story",
    title: "婚姻故事",
    en: "Marriage Story",
    year: "2019",
    region: "美国",
    director: "诺亚·鲍姆巴赫",
    rating: "R",
    genres: ["marriage", "family"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20illustration%20of%20two%20people%20sitting%20back%20to%20back%20in%20an%20empty%20sunlit%20room%2C%20muted%20terracotta%20and%20cream%20tones%2C%20quiet%20tension%20and%20emotional%20distance%2C%20soft%20film%20grain%2C%20artistic%20minimal%20composition&width=600&height=900&seq=work-marriage-story&orientation=portrait",
    summary:
      "一位剧场导演与演员妻子决定和平分手，却在一纸离婚协议里被专业流程推入更深的对抗。两人各自的委屈被拆成立场鲜明的两半。",
    review:
      "影片最诚实的地方，是它对「没有坏人」的坚持。开场的双方自述充满爱意，结尾的系鞋带又把这份爱还了回来。中间那场爆发式争吵之所以著名，正因为它同时成立：两个人说的都对，也都伤人。",
    themes: ["离婚的拉扯", "体面的代价", "仍然存在的爱"],
  },
  {
    id: "blue-valentine",
    title: "蓝色情人节",
    en: "Blue Valentine",
    year: "2010",
    region: "美国",
    director: "德里克·斯安弗朗斯",
    rating: "R",
    genres: ["marriage"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20mood%20illustration%20of%20a%20faded%20couple%20in%20muted%20blue%20and%20grey%20tones%20standing%20in%20a%20rainy%20parking%20lot%2C%20melancholic%20intimate%20atmosphere%2C%20blurred%20bokeh%2C%20soft%20film%20grain&width=600&height=900&seq=work-blue-valentine&orientation=portrait",
    summary:
      "影片用两条时间线交错讲述一对夫妻：一边是相恋时的甜，一边是婚姻濒临破裂时的钝痛。同一件白衬衫，在不同时间点呈现出截然不同的重量。",
    review:
      "它拒绝了所有因果安慰。观众会本能地想找出「哪里出错了」，但影片偏不给答案——有些关系不是被某件事毁掉的，而是被日复一日的错位磨掉的。两位演员的即兴感让这份疲惫格外真实。",
    themes: ["亲密耗损", "记忆的滤镜", "说不清原因的离散"],
  },
  {
    id: "gone-girl",
    title: "消失的爱人",
    en: "Gone Girl",
    year: "2014",
    region: "美国",
    director: "大卫·芬奇",
    rating: "R",
    genres: ["marriage", "moral"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20illustration%20of%20an%20empty%20well%20kept%20suburban%20house%20at%20cold%20dawn%2C%20pale%20misty%20light%2C%20quiet%20uneasy%20atmosphere%2C%20muted%20grey%20green%20palette%2C%20soft%20film%20grain&width=600&height=900&seq=work-gone-girl&orientation=portrait",
    summary:
      "妻子在结婚纪念日离奇失踪，丈夫迅速成为舆论与警方的头号怀疑对象。真相层层翻转，婚姻被拆解成一场精心策划的表演。",
    review:
      "它把「婚姻是一场演出」这个命题推到极端：每个人都在为观众表演一个版本。芬奇的冷调影像让中产体面显出寒意。比起悬疑，它更像一面镜子——问的是我们究竟爱着对方，还是爱着自己被爱的样子。",
    themes: ["表演型婚姻", "媒体审判", "控制的博弈"],
  },
  {
    id: "her",
    title: "她",
    en: "Her",
    year: "2013",
    region: "美国",
    director: "斯派克·琼斯",
    rating: "R",
    genres: ["urban", "youth"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20illustration%20of%20warm%20blurred%20city%20lights%20seen%20through%20a%20rain%20covered%20window%20at%20night%2C%20lonely%20intimate%20mood%2C%20amber%20and%20rose%20tones%2C%20shallow%20depth%20of%20field%2C%20soft%20grain&width=600&height=900&seq=work-her&orientation=portrait",
    summary:
      "在近未来的洛杉矶，一个刚离婚的孤独男人爱上了一套会思考的人工智能系统。影片用温暖的色调讲述一个冰冷的问题：当技术能回应一切，人还愿意真实地爱吗？",
    review:
      "它表面是科幻爱情，内核是当代孤独的精确画像。对方越懂得倾听，人与人之间的笨拙就越显刺眼。结尾他选择与真人同事一起登上天台，是一个很小却必要的和解姿态。",
    themes: ["都市孤独", "亲密的技术替代", "真实的笨拙"],
  },
  {
    id: "the-dreamers",
    title: "戏梦巴黎",
    en: "The Dreamers",
    year: "2003",
    region: "法国 / 英国",
    director: "贝纳尔多·贝托鲁奇",
    rating: "NC-17",
    genres: ["forbidden", "youth"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20illustration%20of%20a%20cluttered%20Parisian%20apartment%20filled%20with%20stacked%20books%20and%20warm%20lamplight%2C%20vintage%201960s%20bohemian%20atmosphere%2C%20warm%20sepia%20tones%2C%20soft%20film%20grain&width=600&height=900&seq=work-dreamers&orientation=portrait",
    summary:
      "1968 年学运前夕，一位美国交换生卷入巴黎一对孪生兄妹封闭而危险的三人世界。电影、政治与越界的情欲在公寓里交织成一场漫长的青春期。",
    review:
      "影片被打上 NC-17，但真正让它成为「禁忌」讨论对象的，是它对边界的层层试探：兄妹之间、师生之间、理想与暴力之间。它不提供道德结论，只把失序的青春完整地摊开。",
    themes: ["青春越界", "电影与理想", "没有出路的亲密"],
  },
  {
    id: "lolita",
    title: "洛丽塔",
    en: "Lolita",
    year: "1997",
    region: "美国 / 法国",
    director: "阿德里安·莱恩",
    rating: "R",
    genres: ["forbidden"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20illustration%20of%20a%20vintage%20car%20on%20a%20long%20empty%20country%20road%20at%20hazy%20golden%20hour%2C%20retro%20melancholic%20mood%2C%20warm%20faded%20palette%2C%20soft%20film%20grain%2C%20distant%20horizon&width=600&height=900&seq=work-lolita&orientation=portrait",
    summary:
      "一个中年男子对继女产生越界的情感，并以叙述者的视角讲述自己的「理由」。影片始终让你警惕：谁在说话，谁在为谁辩解。",
    review:
      "处理这类题材，关键不在呈现，而在视角的自觉。原作与改编都刻意让叙述者不可靠，逼迫观众意识到：一旦进入一个人的自辩，判断力有多容易被语言驯服。它更像一份关于「讲述权」的文本。",
    themes: ["不可靠叙述", "禁忌与辩护", "视角的陷阱"],
  },
  {
    id: "sex-lies-videotape",
    title: "性、谎言和录像带",
    en: "Sex, Lies, and Videotape",
    year: "1989",
    region: "美国",
    director: "史蒂文·索德伯格",
    rating: "R",
    genres: ["marriage", "moral"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20illustration%20of%20an%20old%20camcorder%20resting%20on%20a%20wooden%20table%20beside%20a%20blank%20tape%2C%20muted%20earthy%20palette%2C%20introspective%20quiet%20mood%2C%20soft%20directional%20light%2C%20film%20grain&width=600&height=900&seq=work-sex-lies-videotape&orientation=portrait",
    summary:
      "一个无法拥有性生活的男子搬进旧友的城市，用录像机记录与他人的私密谈话。四角关系在坦白与谎言之间松动，最终逼出各自的真相。",
    review:
      "这部低成本独立片用一间客厅完成了整场伦理实验：秘密不是因为被隐藏才有力量，而是因为有人愿意倾听才无处可藏。它提醒我们，诚实有时比欲望更令人不安。",
    themes: ["秘密与坦白", "倾听的力量", "关系里的真相"],
  },
  {
    id: "the-reader",
    title: "朗读者",
    en: "The Reader",
    year: "2008",
    region: "美国 / 德国",
    director: "史蒂芬·达尔德里",
    rating: "R",
    genres: ["forbidden", "moral"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20illustration%20of%20an%20old%20library%20staircase%20with%20towering%20shelves%20of%20aged%20books%2C%20warm%20dusty%20light%20beam%2C%20quiet%20reflective%20atmosphere%2C%20sepia%20and%20amber%20tones%2C%20soft%20film%20grain&width=600&height=900&seq=work-reader&orientation=portrait",
    summary:
      "少年与一位年长女性的隐秘关系，多年后与一段沉重的历史审判相遇。影片把个人羞耻与集体罪责层层叠放在同一个人物身上。",
    review:
      "它最难的地方，是拒绝把人物简化成「好人」或「恶人」。当一个人既值得同情又背负罪责，观众的道德直觉会被反复拉扯。这正是伦理片最有价值的时刻：不是替你判断，而是让你难以轻易判断。",
    themes: ["历史与罪责", "羞耻的隐瞒", "复杂的人性"],
  },
];